import { CountryCode } from 'services/cfg/countries'

// For convention and compatibility with languages we use ISO 3166-1 alpha-2 codes (https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2) as country codes
export const SUPPORTED_COUNTRY_CODES: Extract<CountryCode, 'IT' | 'SE'>[] = [
  'IT',
  'SE',
]
// export const SUPPORTED_COUNTRY_CODES: CountryCode[] = [ 'IT', 'SE' ] as const
export type SupportedCountryCode = typeof SUPPORTED_COUNTRY_CODES[number]
// the language type is the identifier of the language ISO 639-1 (https://www.w3schools.com/tags/ref_language_codes.asp) that we use to store user preference in the browser
export type LanguageCode = 'it' | 'sv' | 'en'

// LanguageCode is a string chosen between the IETF language tag convention, we use it for localizing date formats
// we can find all entries at this address http://www.lingoes.net/en/translator/langcode.htm
export type LocaleCode = 'it-IT' | 'sv-SE' | 'en-US'

// NB!! the type below should be defined as a type literal: `${LanguageCode}-${CountryCode} where country code is capital`
// this is not allowed in this TS version, but let's be careful to respect this constraint
export type I18nFile = 'en-IT' | 'en-SE' | 'it-IT' | 'sv-SE'

export type I18nBinding = {
  languageCode: LanguageCode
  localeCode: LocaleCode
  i18nFile: I18nFile
  langLabel: string
}
export type CountryInfo = I18nBinding & {
  code: SupportedCountryCode
  name: CountryName
  secondaryLangs: I18nBinding[]
  geoareas: number[]
}

export type CountryName = 'Italia' | 'Sweden'

export const ENG_LANG_TYPE: LanguageCode = 'en'

const ENGLISH_LANGUAGE: Omit<I18nBinding, 'i18nFile'> = {
  languageCode: ENG_LANG_TYPE,
  localeCode: 'en-US',
  langLabel: 'language.label.english',
}

export const COUNTRY_IT: CountryInfo = {
  name: 'Italia',
  code: 'IT',
  localeCode: 'it-IT',
  languageCode: 'it',
  i18nFile: 'it-IT',
  langLabel: 'language.label.italian',
  geoareas: [1],
  secondaryLangs: [
    {
      ...ENGLISH_LANGUAGE,
      i18nFile: 'en-IT',
    },
  ],
}

export const COUNTRY_SV: CountryInfo = {
  name: 'Sweden',
  code: 'SE',
  localeCode: 'sv-SE',
  languageCode: 'sv',
  i18nFile: 'sv-SE',
  langLabel: 'language.label.swedish',
  geoareas: [2],
  secondaryLangs: [
    {
      ...ENGLISH_LANGUAGE,
      i18nFile: 'en-SE',
    },
  ],
}

export const SUPPORTED_COUNTRIES: CountryInfo[] = [COUNTRY_IT, COUNTRY_SV]

export const DEFAULT_COUNTRY_CODE = COUNTRY_IT.code as 'IT'

export default SUPPORTED_COUNTRIES
